import { render, staticRenderFns } from "./AnnouncementsSingle.vue?vue&type=template&id=41c2d99b&"
import script from "./AnnouncementsSingle.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsSingle.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports